import type { ReactNode } from 'react'
import { useContext } from 'react'

import { createSharedContext } from '@twistopayments/design-system/utils'

import type { HeadlineSize } from './headline'

/**
 * Context
 */

type SizeValue = HeadlineSize | undefined

const Context = createSharedContext<SizeValue>('components/atoms/headline/size-context#0', undefined)

/**
 * Provider
 */

type Props = {
  children: ReactNode
  size: HeadlineSize
}

export const SizeProvider = ({ children, size }: Props) => (
  <Context.Provider value={size}>{children}</Context.Provider>
)

/**
 * Hook
 */

export const useSize = () => {
  const context = useContext(Context)

  if (context === undefined) {
    throw new Error('useSize must be used within a SizeProvider')
  }

  return context
}
